"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxTabsRearrangeSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const molecules_1 = require("../../molecules");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const InfoBoxTabsList_1 = require("../../molecules/InfoBoxTabsList");
const pages_1 = require("../../pages");
const styled_components_1 = __importDefault(require("styled-components"));
function InfoBoxTabsRearrangeSection() {
    const { isMobile } = (0, device_1.usePlatform)();
    const [reorderPageOpened, toggleReorderPageOpened] = (0, ui_1.useToggleState)(false);
    if (isMobile) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(molecules_1.PreferencesSection, { title: (0, jsx_runtime_1.jsxs)(TitleContainer, { children: [(0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.displayOrder), (0, jsx_runtime_1.jsx)(ShowMoreIcon, { name: ui_1.Icons.Arrow_Right })] }), 
                    // onClick={() => navigate('/reorder')}
                    onClick: toggleReorderPageOpened, "data-e2e": 'InfoBoxTabsRearrangeSection_PreferencesSection', children: (0, jsx_runtime_1.jsx)(StyledInfoboxFeaturesOrderList, { "data-e2e": 'InfoBoxTabsRearrangeSection_StyledInfoboxFeaturesOrderList' }) }), reorderPageOpened && (
                /* @todo use router */
                (0, jsx_runtime_1.jsx)(pages_1.InfoBoxTabsRearrangePage, { onBack: toggleReorderPageOpened, "data-e2e": 'InfoBoxTabsRearrangeSection_InfoBoxTabsRearrangePage' }))] }));
    }
    return ((0, jsx_runtime_1.jsxs)(molecules_1.PreferencesSection, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.displayOrder), "data-e2e": 'InfoBoxTabsRearrangeSection_PreferencesSection', children: [(0, jsx_runtime_1.jsx)(molecules_1.DnDHint, { "data-e2e": 'InfoBoxTabsRearrangeSection_DnDHint' }), (0, jsx_runtime_1.jsx)(molecules_1.InfoBoxTabsOrder, { "data-e2e": 'InfoBoxTabsRearrangeSection_InfoBoxTabsOrder' })] }));
}
exports.InfoBoxTabsRearrangeSection = InfoBoxTabsRearrangeSection;
const TitleContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;

  padding-left: calc(24px + env(safe-area-inset-left));
  padding-left: calc(24px + constant(safe-area-inset-left));
`;
const ShowMoreIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 15px;
  height: 15px;

  margin-right: auto;
  margin-left: 8px;
`;
const StyledInfoboxFeaturesOrderList = (0, styled_components_1.default)(InfoBoxTabsList_1.InfoBoxTabsList) `
  padding-right: calc(24px + env(safe-area-inset-right));
  padding-right: calc(24px + constant(safe-area-inset-right));
  padding-left: calc(24px + env(safe-area-inset-left));
  padding-left: calc(24px + constant(safe-area-inset-left));
`;
